import { render } from "./accordionInfo.vue?vue&type=template&id=32b5ad9a"
import script from "./accordionInfo.vue?vue&type=script&lang=js"
export * from "./accordionInfo.vue?vue&type=script&lang=js"

import "./accordionInfo.vue?vue&type=style&index=0&id=32b5ad9a&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__